"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SERVICE_END_POINTS;
(function (SERVICE_END_POINTS) {
    SERVICE_END_POINTS["CDD_SERVICE"] = "/CDDService";
    SERVICE_END_POINTS["EAD_SERVICE"] = "/EADService";
    SERVICE_END_POINTS["CMR_SERVICE"] = "/CMRService";
    SERVICE_END_POINTS["RCN_SERVICE"] = "/RCNService";
    SERVICE_END_POINTS["PING_SERVICE"] = "/Ping";
})(SERVICE_END_POINTS = exports.SERVICE_END_POINTS || (exports.SERVICE_END_POINTS = {}));
var SSO_ACTIONS;
(function (SSO_ACTIONS) {
    SSO_ACTIONS["SCHEDULE_EXAM"] = "scheduleExam";
    SSO_ACTIONS["RESCHEDULE_EXAM"] = "rescheduleExam";
    SSO_ACTIONS["CANCEL_EXAM"] = "cancelExam";
    SSO_ACTIONS["VIEW_EXAM_CATALOG"] = "viewExamCatalog";
    SSO_ACTIONS["VIEW_APPOINTMENT_ACTIVITY_FOR_REGISTRATION_ID"] = "viewAppointmentActivityForRegistrationID";
    SSO_ACTIONS["VIEW_MY_RECEIPTS"] = "viewMyReceipts";
    SSO_ACTIONS["INDIVIDUAL_SCORE_REPORT"] = "individualScoreReport";
    SSO_ACTIONS["VIEW_SCORE_REPORT"] = "viewScoreReport";
    SSO_ACTIONS["VIEW_EXAM_HISTORY"] = "viewExamHistory";
})(SSO_ACTIONS = exports.SSO_ACTIONS || (exports.SSO_ACTIONS = {}));
var EAD_AUTH_TRANSACTION_TYPE;
(function (EAD_AUTH_TRANSACTION_TYPE) {
    EAD_AUTH_TRANSACTION_TYPE["ADD"] = "Add";
    EAD_AUTH_TRANSACTION_TYPE["UPDATE"] = "Update";
    EAD_AUTH_TRANSACTION_TYPE["DELETE"] = "Delete";
})(EAD_AUTH_TRANSACTION_TYPE = exports.EAD_AUTH_TRANSACTION_TYPE || (exports.EAD_AUTH_TRANSACTION_TYPE = {}));
var ModifyAppointmentEvents;
(function (ModifyAppointmentEvents) {
    ModifyAppointmentEvents["APPT_CREATED"] = "APPT_CREATED";
    ModifyAppointmentEvents["APPT_RESCHEDULED"] = "APPT_RESCHEDULED";
    ModifyAppointmentEvents["ACCOMMODATION_UPDATED"] = "ACCOMMODATION_UPDATED";
    ModifyAppointmentEvents["EXAM_DELIVERED"] = "EXAM_DELIVERED";
    ModifyAppointmentEvents["NO_SHOW"] = "NO_SHOW";
    ModifyAppointmentEvents["NDA_REFUSED"] = "NDA_REFUSED";
    ModifyAppointmentEvents["EXPIRED"] = "EXPIRED";
    ModifyAppointmentEvents["APPT_CANCELED"] = "APPT_CANCELED";
})(ModifyAppointmentEvents = exports.ModifyAppointmentEvents || (exports.ModifyAppointmentEvents = {}));
var ResultNotificationEvents;
(function (ResultNotificationEvents) {
    ResultNotificationEvents["RESULT_AVAILABLE"] = "RESULT_AVAILABLE";
})(ResultNotificationEvents = exports.ResultNotificationEvents || (exports.ResultNotificationEvents = {}));
var ExamType;
(function (ExamType) {
    ExamType["objectiveTest"] = "Objective Test";
    ExamType["caseStudy"] = "Case Study";
})(ExamType = exports.ExamType || (exports.ExamType = {}));
var ExamResultStatus;
(function (ExamResultStatus) {
    ExamResultStatus["pass"] = "Pass";
    ExamResultStatus["fail"] = "Fail";
    ExamResultStatus["taken"] = "Taken";
    ExamResultStatus["noShow"] = "No Show";
    ExamResultStatus["ndaRefused"] = "NDA Refused";
    ExamResultStatus["pending"] = "Pending";
    ExamResultStatus["malpractise"] = "Malpractise";
})(ExamResultStatus = exports.ExamResultStatus || (exports.ExamResultStatus = {}));
var ExamResultRatificationStatus;
(function (ExamResultRatificationStatus) {
    ExamResultRatificationStatus["ratified"] = "Ratified";
    ExamResultRatificationStatus["pendingRatification"] = "Pending Ratification";
    ExamResultRatificationStatus["onHold"] = "Onhold";
})(ExamResultRatificationStatus = exports.ExamResultRatificationStatus || (exports.ExamResultRatificationStatus = {}));
var ExamBookingStatus;
(function (ExamBookingStatus) {
    ExamBookingStatus["active"] = "Active";
    ExamBookingStatus["cancelled"] = "Cancelled";
    ExamBookingStatus["delivered"] = "Delivered";
    ExamBookingStatus["noShow"] = "No Show";
    ExamBookingStatus["ndaRefused"] = "NDA Refused";
})(ExamBookingStatus = exports.ExamBookingStatus || (exports.ExamBookingStatus = {}));
var ExamResultOutcomeType;
(function (ExamResultOutcomeType) {
    ExamResultOutcomeType["original"] = "ORIGINAL";
    ExamResultOutcomeType["rescore"] = "RESCORE";
})(ExamResultOutcomeType = exports.ExamResultOutcomeType || (exports.ExamResultOutcomeType = {}));
var ExamResultGrade;
(function (ExamResultGrade) {
    ExamResultGrade["pass"] = "PASS";
    ExamResultGrade["fail"] = "FAIL";
    ExamResultGrade["taken"] = "TAKEN";
    ExamResultGrade["refused"] = "REFUSED";
})(ExamResultGrade = exports.ExamResultGrade || (exports.ExamResultGrade = {}));
var EXAM_AUTH_STATUS;
(function (EXAM_AUTH_STATUS) {
    EXAM_AUTH_STATUS["ACTIVE"] = "Active";
    EXAM_AUTH_STATUS["CONSUMED"] = "Consumed";
    EXAM_AUTH_STATUS["REVOKED"] = "Revoked";
})(EXAM_AUTH_STATUS = exports.EXAM_AUTH_STATUS || (exports.EXAM_AUTH_STATUS = {}));
var ExamResultOverrideStatus;
(function (ExamResultOverrideStatus) {
    ExamResultOverrideStatus["misconduct"] = "Misconduct";
    ExamResultOverrideStatus["voided"] = "Voided";
    ExamResultOverrideStatus["technicalError"] = "Technical Error";
    ExamResultOverrideStatus["none"] = "None";
})(ExamResultOverrideStatus = exports.ExamResultOverrideStatus || (exports.ExamResultOverrideStatus = {}));
var ExamAutoPublishMode;
(function (ExamAutoPublishMode) {
    ExamAutoPublishMode["immediate"] = "Immediate";
    ExamAutoPublishMode["delayed"] = "Delayed";
    ExamAutoPublishMode["disableAutoPublish"] = "Disable auto publish";
})(ExamAutoPublishMode = exports.ExamAutoPublishMode || (exports.ExamAutoPublishMode = {}));
//# sourceMappingURL=enums.js.map